import { render, staticRenderFns } from "./ProClassManagement.vue?vue&type=template&id=9b6c1bda&scoped=true&"
import script from "./ProClassManagement.vue?vue&type=script&lang=js&"
export * from "./ProClassManagement.vue?vue&type=script&lang=js&"
import style0 from "./ProClassManagement.vue?vue&type=style&index=0&id=9b6c1bda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6c1bda",
  null
  
)

export default component.exports